import React from 'react';
import { colors, fontFamily, fontWeight } from '@mergermarket/acuris-react-styles';
import styled, { keyframes, css } from 'styled-components';

const waveHeight = keyframes`
  0% {
    height: 30%
  }
  50% {
    height: 100%;
  }
  100% {
    height: 30%;
  }
`;
const sizes = {
  small: {
    height: '16px',
    width: '18px',
    bar: '2px',
    fontSize: '1.2rem'
  },
  medium: {
    height: '32px',
    width: '31px',
    bar: '3px',
    fontSize: '1.2rem'
  },
  large: {
    height: '48px',
    width: '48px',
    bar: '5px',
    fontSize: '1.4rem'
  },
  xlarge: {
    height: '64px',
    width: '64px',
    bar: '6px',
    fontSize: '1.6rem'
  }
};
const getSize = (size = 'medium') => sizes[size] || sizes.medium;
const LoaderIndicatorContainer = styled.div`
  display: ${props => props.isVisible ? 'flex' : 'none'};
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
`;
const LoaderIndicatorBarContainer = styled.div`
  ${props => props.isWithOverlay ? `position: absolute;` : ''}
  ${props => props.isWithOverlay ? `top: ${getSize(props.size).height};` : ''}
  height: ${props => getSize(props.size).height};
  width: ${props => getSize(props.size).width};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const LoaderBar = styled.div`
  background: ${colors.primaryBrand};
  ${props => css`
    width: ${getSize(props.size).bar};
    height: ${100 - props.order * 17.5}%;
    animation: 1s ${props.order / 10}s infinite ${waveHeight};
  `}
`;
const LoaderText = styled.h4`
  font-family: ${fontFamily.primary};
  text-align: center;
  margin: 0;
  padding-top: 0.8rem;
  font-weight: ${fontWeight.normal};
  font-size: ${props => getSize(props.size).fontSize};
`;

const LoaderIndicator = props => /*#__PURE__*/React.createElement(LoaderIndicatorContainer, {
  isVisible: Boolean(props.isVisible),
  className: props.className,
  "data-testid": "LoaderIndicatorContainer"
}, /*#__PURE__*/React.createElement(LoaderIndicatorBarContainer, {
  size: props.size,
  isWithOverlay: Boolean(props.isWithOverlay),
  "data-testid": "LoaderIndicatorBarContainer"
}, Array.from({
  length: 5
}, (_, i = 0) => /*#__PURE__*/React.createElement(LoaderBar, {
  key: i,
  order: i,
  size: props.size,
  "data-testid": "LoaderBar"
}))), props.text && /*#__PURE__*/React.createElement(LoaderText, {
  role: "dialog",
  "data-testid": "LoaderText"
}, props.text));

export default LoaderIndicator;
export { LoaderIndicatorBarContainer };
//# sourceMappingURL=index.js.map
